// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"vpn-verify-styles_loadingContainer__2pgKX","ellipsis":"vpn-verify-styles_ellipsis___G6H6","typing":"vpn-verify-styles_typing__1Z_kF"};